var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiBox from '@material-ui/core/Box';
var BoxRefRender = function (props, ref) { return React.createElement(MuiBox, __assign({}, props, { ref: ref })); };
/**
 * Kareo wrapped component of the Material-UI Box. The prop API has been limited to props defined in BoxProps.
 *
 * The Box component serves as a wrapper component for most of the CSS utility needs.
 *
 * Material-UI Box: [System Usage](https://v4.mui.com/system/basics/#all-inclusive), [Docs](https://v4.mui.com/components/box/)
 *
 * @storybook: [Box](http://design.kareoprod.ent/design-system/?path=/docs/components-layout-box--box-simple)
 */
var Box = React.forwardRef(BoxRefRender);
Box.displayName = 'KareoBox';
export default Box;
